const getPreferenceCenterCountrySelect = require("./getPreferenceCenterCountrySelect");
const showPreferenceCenterSmsSection = require("./showPreferenceCenterSmsSection");
const hidePreferenceCenterPhoneNumberField = require("./hidePreferenceCenterPhoneNumberField");
const hidePreferenceCenterSmsSection = require("./hidePreferenceCenterSmsSection");
const uncheckPreferenceCenterSmsCheckbox = require("./uncheckPreferenceCenterSmsCheckbox");
const hidePreferenceCenterSmsNotAvailableInYourCountry = require("./hidePreferenceCenterSmsNotAvailableInYourCountry");
const showPreferenceCenterSmsNotAvailableInYourCountry = require("./showPreferenceCenterSmsNotAvailableInYourCountry");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function updateSmsAvailability(preferenceCenter) {
    const countrySelect = getPreferenceCenterCountrySelect(preferenceCenter);

    if (countrySelect.value === "United States") {
        showPreferenceCenterSmsSection(preferenceCenter);
        hidePreferenceCenterSmsNotAvailableInYourCountry(preferenceCenter);
    } else {
        hidePreferenceCenterPhoneNumberField(preferenceCenter);
        hidePreferenceCenterSmsSection(preferenceCenter);
        uncheckPreferenceCenterSmsCheckbox(preferenceCenter);
        showPreferenceCenterSmsNotAvailableInYourCountry(preferenceCenter);
    }
}
